// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Palette with safe fallbacks */
/* Gold palette for borders */
/* classic gold */
/* light highlight */
/* deep shadow */
/* Subtle inner gradient tints (very thin/soft) */
/* 6% gold → barely there */
/* Match button radius if defined; compact default otherwise */
/* ---------- Pure white card + THIN inner gradient + gold BORDER ---------- */
.ccard {
  font-family: "Almendra";
  position: relative;
  border-radius: 11px;
  /* inner (padding-box) now has a very thin gradient; border (border-box) is gold */
  border: 2px solid transparent;
  background: linear-gradient(180deg, #ffffff 0%, rgb(254.1, 253.2, 249.36) 100%) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  animation: ccard-fade 0.45s ease-out both;
  transition: transform 0.25s ease, box-shadow 0.35s ease;
}
.ccard:hover {
  transform: translateY(-2px);
}

/* Inner layout */
.ccard__inner {
  background: transparent; /* gradient comes from parent via padding-box layer */
  border-radius: calc(11px - 1px);
  padding: 0.9rem; /* compact */
  display: grid;
  gap: 0.7rem;
}
@media (min-width: 820px) {
  .ccard__inner {
    grid-template-columns: 1.1fr 1fr;
    align-items: stretch;
  }
}

/* Hide if the ribbon element still exists */
.ccard__ribbon {
  display: none;
}

@keyframes ccard-fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
/* Content */
.ccard__content {
  display: grid;
  gap: 0.7rem;
}

/* Title (commented out in JSX) — keeping style here for later use */
.ccard__title {
  font-family: "Almendra", serif;
  font-weight: 700;
  letter-spacing: 0.15px;
  color: #0b0b0c;
  margin: 0;
  line-height: 1.1;
  font-size: clamp(1.6rem, 4.2vw, 2.4rem);
}

/* ---------- Rows (icon BEFORE label) with thin inner gradient + gold BORDER ---------- */
.ccard__rows {
  display: grid;
  gap: 0.7rem;
}

.ccard__row {
  padding: 0.6rem 0.6rem 0.65rem;
  border-radius: 12px;
  /* subtle inner gradient per row so the whole card feels filled */
  background: linear-gradient(180deg, #fff 0%, rgb(254.4, 253.8, 251.24) 100%) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box; /* gold border */
  border: 1.5px solid transparent; /* enables gradient border */
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.7) inset, 0 6px 14px rgba(0, 0, 0, 0.04);
}

.ccard__head {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.15rem;
}

.ccard__headIcon {
  color: #926F34; /* set to \$gold-1 if you want gold icons */
  display: inline-flex;
}
.ccard__headIcon svg {
  width: 16px;
  height: 16px;
}

.ccard__headLabel {
  font-size: 0.74rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
}

.ccard__value {
  font-size: 0.95rem;
  color: #0b0b0c;
  line-height: 1.4;
}

.ccard__muted {
  color: #6b7280;
}

.ccard__actions {
  margin-top: 0.25rem;
}

/* Button inside the card — slightly smaller to match compact scale */
.ccard .ui-btn {
  height: 2.5rem;
  padding: 0 0.95rem;
  font-size: 0.92rem;
}

/* ---------- Map (pure white inside, gold BORDER) ---------- */
.ccard__map {
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(#ffffff, #ffffff) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box; /* gold border */
  border: 1.5px solid transparent;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.4);
}

.ccard__mapFrame {
  width: 100%;
  aspect-ratio: 5/4; /* slightly shorter overall */
}
@media (min-width: 1024px) {
  .ccard__mapFrame {
    aspect-ratio: 3/2;
  }
}
.ccard__mapFrame iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

/* ---------- Optional: 'dark' variant stays white interior, thin gradient, gold border ---------- */
.ccard--dark {
  border: 2px solid transparent;
  background: linear-gradient(180deg, #ffffff 0%, rgb(254.1, 253.2, 249.36) 100%) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}
.ccard--dark .ccard__title {
  color: #0b0b0c;
}
.ccard--dark .ccard__row {
  background: linear-gradient(180deg, #fff 0%, rgb(254.4, 253.8, 251.24) 100%) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  border: 1.5px solid transparent;
}
.ccard--dark .ccard__headLabel {
  color: #6b7280;
}
.ccard--dark .ccard__value {
  color: #0b0b0c;
}
.ccard--dark .ccard__headIcon {
  color: #926F34;
}
.ccard--dark { /* or \$gold-1 for gold icons */ }
.ccard--dark .ccard__map {
  background: linear-gradient(#ffffff, #ffffff) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  border: 1.5px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/CardComponent/CardComponent.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB,gCAAA;AAKA,6BAAA;AACmB,iBAAA;AACA,oBAAA;AACA,gBAAA;AAEnB,iDAAA;AAEiD,2BAAA;AAEjD,8DAAA;AAGA,8EAAA;AACA;EACE,uBAAA;EACA,kBAAA;EACA,mBANY;EAQZ,kFAAA;EACA,6BAAA;EACA,8JACE;EAGF,0CAAA;EACA,yCAAA;EACA,uDAAA;AAdF;AAgBE;EAAU,2BAAA;AAbZ;;AAgBA,iBAAA;AACA;EACE,uBAAA,EAAA,qDAAA;EACA,+BAAA;EACA,eAAA,EAAA,YAAA;EACA,aAAA;EACA,WAAA;AAbF;AAeE;EAPF;IAQI,gCAAA;IACA,oBAAA;EAZF;AACF;;AAeA,4CAAA;AACA;EAAiB,aAAA;AAXjB;;AAaA;EACE;IAAO,UAAA;IAAY,0BAAA;EARnB;EASA;IAAO,UAAA;IAAY,eAAA;EALnB;AACF;AAOA,YAAA;AACA;EAAkB,aAAA;EAAe,WAAA;AAHjC;;AAKA,oEAAA;AACA;EACE,8BAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAhEQ;EAiER,SAAA;EACA,gBAAA;EACA,uCAAA;AAFF;;AAKA,0FAAA;AACA;EAAe,aAAA;EAAe,WAAA;AAA9B;;AAEA;EACE,8BAAA;EACA,mBAAA;EAEA,iEAAA;EACA,2JACE,EACoF,gBAAA;EAEtF,+BAAA,EAAA,4BAAA;EACA,kFACE;AAJJ;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AALF;;AAQA;EACE,cAjGQ,EAiGS,0CAAA;EACjB,oBAAA;AALF;AAOE;EAAM,WAAA;EAAa,YAAA;AAHrB;;AAMA;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAzGQ;AAsGV;;AAMA;EACE,kBAAA;EACA,cA/GQ;EAgHR,gBAAA;AAHF;;AAMA;EAAgB,cAlHN;AAgHV;;AAGA;EAAkB,mBAAA;AAClB;;AACA,qEAAA;AACA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AAEF;;AACA,+DAAA;AACA;EACE,mBAAA;EACA,gBAAA;EACA,4HACE,EACuE,gBAAA;EACzE,+BAAA;EACA,oDAAA;AAAF;;AAGA;EACE,WAAA;EACA,iBAAA,EAAA,6BAAA;AAAF;AACE;EAHF;IAG+B,iBAAA;EAG7B;AACF;AAFE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAIJ;;AAAA,oGAAA;AACA;EACE,6BAAA;EACA,8JACE;EAGF,2CAAA;AAAF;AAEE;EAAgB,cA9JR;AA+JV;AACE;EACE,2JACE;EAEF,+BAAA;AADJ;AAIE;EAAoB,cAtKZ;AAqKV;AAEE;EAAoB,cAxKZ;AAyKV;AAAE;EAAoB,cA1KZ;AA6KV;AAtBA,eAmByC,8BAAA,EAAA;AAEvC;EACE,4HACE;EAEF,+BAAA;AAEJ","sourcesContent":["@use \"sass:color\";\r\n@use \"../styles/tokens\" as *; // shared tokens (primary, text, etc.)\r\n\r\n/* Palette with safe fallbacks */\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n\r\n/* Gold palette for borders */\r\n$gold-1: #d4af37;  /* classic gold */\r\n$gold-2: #f0e1a1;  /* light highlight */\r\n$gold-3: #b38728;  /* deep shadow */\r\n\r\n/* Subtle inner gradient tints (very thin/soft) */\r\n$inner-stop-1: #ffffff;\r\n$inner-stop-2: color.mix(#ffffff, $gold-2, 94%); /* 6% gold → barely there */\r\n\r\n/* Match button radius if defined; compact default otherwise */\r\n$card-radius: if(global-variable-exists(btn-radius), $btn-radius, 16px);\r\n\r\n/* ---------- Pure white card + THIN inner gradient + gold BORDER ---------- */\r\n.ccard {\r\n  font-family: 'Almendra';\r\n  position: relative;\r\n  border-radius: $card-radius;\r\n\r\n  /* inner (padding-box) now has a very thin gradient; border (border-box) is gold */\r\n  border: 2px solid transparent;\r\n  background:\r\n    linear-gradient(180deg, $inner-stop-1 0%, $inner-stop-2 100%) padding-box,\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, .06);\r\n  animation: ccard-fade .45s ease-out both;\r\n  transition: transform .25s ease, box-shadow .35s ease;\r\n\r\n  &:hover { transform: translateY(-2px); }\r\n}\r\n\r\n/* Inner layout */\r\n.ccard__inner {\r\n  background: transparent; /* gradient comes from parent via padding-box layer */\r\n  border-radius: calc(#{$card-radius} - 1px);\r\n  padding: .9rem;          /* compact */\r\n  display: grid;\r\n  gap: .7rem;\r\n\r\n  @media (min-width: 820px) {\r\n    grid-template-columns: 1.1fr 1fr;\r\n    align-items: stretch;\r\n  }\r\n}\r\n\r\n/* Hide if the ribbon element still exists */\r\n.ccard__ribbon { display: none; }\r\n\r\n@keyframes ccard-fade {\r\n  from { opacity: 0; transform: translateY(4px); }\r\n  to   { opacity: 1; transform: none; }\r\n}\r\n\r\n/* Content */\r\n.ccard__content { display: grid; gap: .7rem; }\r\n\r\n/* Title (commented out in JSX) — keeping style here for later use */\r\n.ccard__title {\r\n  font-family: \"Almendra\", serif;\r\n  font-weight: 700;\r\n  letter-spacing: .15px;\r\n  color: $text;\r\n  margin: 0;\r\n  line-height: 1.1;\r\n  font-size: clamp(1.6rem, 4.2vw, 2.4rem);\r\n}\r\n\r\n/* ---------- Rows (icon BEFORE label) with thin inner gradient + gold BORDER ---------- */\r\n.ccard__rows { display: grid; gap: .7rem; }\r\n\r\n.ccard__row {\r\n  padding: .6rem .6rem .65rem;\r\n  border-radius: 12px;\r\n\r\n  /* subtle inner gradient per row so the whole card feels filled */\r\n  background:\r\n    linear-gradient(180deg, #fff 0%, color.mix(#ffffff, $gold-2, 96%) 100%) padding-box, /* 4% gold */\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;                  /* gold border */\r\n\r\n  border: 1.5px solid transparent; /* enables gradient border */\r\n  box-shadow:\r\n    0 1px 0 rgba(255, 255, 255, .7) inset,\r\n    0 6px 14px rgba(0, 0, 0, .04);\r\n}\r\n\r\n.ccard__head {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: .4rem;\r\n  margin-bottom: .15rem;\r\n}\r\n\r\n.ccard__headIcon {\r\n  color: $primary; /* set to $gold-1 if you want gold icons */\r\n  display: inline-flex;\r\n\r\n  svg { width: 16px; height: 16px; }\r\n}\r\n\r\n.ccard__headLabel {\r\n  font-size: .74rem;\r\n  letter-spacing: .08em;\r\n  text-transform: uppercase;\r\n  color: $muted;\r\n}\r\n\r\n.ccard__value {\r\n  font-size: .95rem;\r\n  color: $text;\r\n  line-height: 1.4;\r\n}\r\n\r\n.ccard__muted { color: $muted; }\r\n.ccard__actions { margin-top: .25rem; }\r\n\r\n/* Button inside the card — slightly smaller to match compact scale */\r\n.ccard .ui-btn {\r\n  height: 2.5rem;\r\n  padding: 0 .95rem;\r\n  font-size: .92rem;\r\n}\r\n\r\n/* ---------- Map (pure white inside, gold BORDER) ---------- */\r\n.ccard__map {\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background:\r\n    linear-gradient(#ffffff, #ffffff) padding-box,                         /* keep map interior pure white */\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;     /* gold border */\r\n  border: 1.5px solid transparent;\r\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .4);\r\n}\r\n\r\n.ccard__mapFrame {\r\n  width: 100%;\r\n  aspect-ratio: 5 / 4; /* slightly shorter overall */\r\n  @media (min-width: 1024px) { aspect-ratio: 3 / 2; }\r\n\r\n  iframe {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 0;\r\n    display: block;\r\n  }\r\n}\r\n\r\n/* ---------- Optional: 'dark' variant stays white interior, thin gradient, gold border ---------- */\r\n.ccard--dark {\r\n  border: 2px solid transparent;\r\n  background:\r\n    linear-gradient(180deg, $inner-stop-1 0%, $inner-stop-2 100%) padding-box, /* same thin gradient */\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .12);\r\n\r\n  .ccard__title { color: $text; }\r\n\r\n  .ccard__row {\r\n    background:\r\n      linear-gradient(180deg, #fff 0%, color.mix(#ffffff, $gold-2, 96%) 100%) padding-box,\r\n      linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n    border: 1.5px solid transparent;\r\n  }\r\n\r\n  .ccard__headLabel { color: $muted; }\r\n  .ccard__value     { color: $text; }\r\n  .ccard__headIcon  { color: $primary; } /* or $gold-1 for gold icons */\r\n\r\n  .ccard__map {\r\n    background:\r\n      linear-gradient(#ffffff, #ffffff) padding-box,\r\n      linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n    border: 1.5px solid transparent;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
